import {Component} from "@angular/core";
import {handleErrors} from "../misc/handle-errors.decorator";
import {CronAdminService} from "./cron-admin.service";
import {CronJobModel} from "./cron-job.model";
import {CronGqlModel} from "./cron.gql-model";
import {NgSwitch} from "@angular/common";

@Component({
  selector: "cron-admin",
  templateUrl: "./cron-admin.template.pug",
  providers: [
    CronAdminService,
    NgSwitch,
  ],
})
export class CronAdminComponent {
  error: Error;
  logData: CronGqlModel[] = [];

  cronJobs: CronJobModel[] = [
    {
      name: "geo-location",
      description: "GeoLocation",
      enabled: true,
    },
    {
      name: "product",
      description: "Product",
      enabled: true,
    },
    {
      name: "contact-locale",
      description: "ContactLocale",
      enabled: true,
    },
    {
      name: "card-expenses",
      description: "CARD Expenses",
      enabled: true,
    },
    {
      name: "smartsheet",
      description: "Smartsheet Report",
      enabled: true,
    },
    {
      name: "workflow-steps",
      description: "Workflow Steps",
      enabled: true,
    },
    {
      name: "dart-deals-import",
      description: "DART Deals",
      enabled: true,
    },
  ];

  @handleErrors()
  async triggerCronJob(job: CronJobModel) {
    await this.cronAdminService.callCronJob(job.name);
  }

  clear() {
    this.logData = [];
  }

  constructor(public cronAdminService: CronAdminService) {
    this.cronAdminService.logEntries.subscribe(
      (result: CronGqlModel) => {
        this.error = undefined;
        this.logData.push(result);
      },
      (error: Error) => {
        this.error = error;
      },
    );
  }
}
